import { combineEpics } from "redux-observable";
const rootEpic = combineEpics();
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
